export default {
	isPqyUser: false,

	resultList: [],
	detailList: [],
	useYnList: [],
	lgrpList: [],
	sgrpList: [],
	sgrpAllList: [],
	ipnWayList: [],
	selectedRows: [],
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		custCd: '',
		custNm: '',
		cpnyScn: '10'
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 5000,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
